import { HStack, Link, Text, VStack } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const CardContainer = HStack.withConfig({
  backgroundColor: theme.token('background-pattern'),
  borderRadius: 'lg',
  paddingY: '$3',
  paddingX: '$4',
  width: 'full',
  alignItems: 'center',
});

export const thumbnailSize = {
  width: '$17.5',
  height: '$13.5',
};

export const ItemImageContainer = VStack.withConfig({
  alignItems: 'center',
});

export const Price = Text.withConfig({
  color: theme.token('text-disabled'),
  fontSize: 'sm',
  lineHeight: 'sm',
});

export const ItemName = Text.withConfig({
  fontFamily: 'heading',
  fontSize: 'md',
  lineHeight: '2xs',
  marginTop: '$1',
});

export const StyledLink = Link.withConfig({
  _web: {
    width: 'fit-content',
    cursor: 'pointer',
    _hover: {
      _text: {
        color: Styles.color.tertiary,
      },
    },
  },
});
